export const heroHeading = {
  fontSize: 80,
  fontWeight: 700,
  color: "#18181B",
  lineHeight: "5rem",
  marginTop: "5rem",
};

export const heroContent = {
  fontSize: 18,
  opacity: ".7",
  lineHeight: "1.75rem",
  margin: "2.25rem 0 2.5rem",
};

export const heroButton = {
  textTransform: "none",
  padding: ".8rem 1.25rem",
  background: "#0B0B0B",
  color: "#ffffff",
  borderRadius: "1rem",
  ":hover": {
    background: "#0B0B0B",
    transition: ".3s",
  },
};

export const verticalDivider = {
  height: "2rem",
  width: "0",
  border: ".063rem solid #000",
  opacity: ".3",
  margin: "0 auto",
};

export const statsHeading = { fontSize: 42, fontWeight: 700 };

export const cardImgAlignment = {
  marginTop: "-25rem",
  marginLeft: "-8rem",
};

export const statsWrapper = { color: "#18181B", marginTop: "4.5rem" };

export const heroButtonText = { fontSize: 18, fontWeight: 700 };
